/**
 * Import da biblioteca "styled-components", que permite escrever
 * CSS simples para os componentes sem acontecer conflitos com os
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import TextareaAutosize from '@mui/base/TextareaAutosize';
import styled from 'styled-components';

/**
 * Estilização do componente Wrap
 */
export const Wrap = styled.div`
  width: 100%;
  height: 100%;

  table {
    display: block;
    overflow: auto;
    height: 93%;

    th,
    td {
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      color: #5e5e5e;
      border-bottom: none;
      padding: 11.5px 16px;
    }

    thead {
      height: 42px;
      background: #f1f1f1;
      position: -webkit-sticky;
      position: sticky;
      top: 0;
      z-index: 2;

      th {
        .sort-icon {
          cursor: pointer;
          &:hover svg {
            color: blue;
          }

          display: inline;
          opacity: 1;
          transition: opacity 500ms;
          &.asc {
            opacity: 1;
            color: blue;
            svg {
              transform: rotate(180deg);
            }
          }
          &.desc {
            opacity: 1;
            color: blue;
            svg {
              transform: rotate(0deg);
            }
          }
          @media (max-width: 768px) {
            color: #3c71dd;
          }
        }
        svg {
          margin-left: 8px;
          transition: transform 500ms;
        }
        /* &:hover {
          .sort-icon {
            opacity: 1;
          }
        }
        &.sorting {
          background: #d9d9d9;
        } */

        &.selected-label-column {
          background: #c7c7c7;
        }

        &.column-editable {
          &:hover {
            background: #dbe7ff;
          }
        }

        &.column-selected {
          background: #cad5eb;
        }
      }
    }

    tbody {
      z-index: 1;

      tr {
        height: 42px;
        &.selected {
          background: #dbe7ff;
        }
        &:hover {
          background: #f2f7ff;
        }
        &.highlightLine {
          background: #ffdbdb;
        }
      }

      td {
        &.selected-label-column {
          background: #f1f1f1;
        }

        &.column-selected {
          background: #dbe7ff;
        }
        /* &:hover {
          background: #f2f7ff;
        } */
      }
    }
  }

  .text-field {
    width: 100px;
    font-size: 12px;
    line-height: 16px;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    letter-spacing: normal;

    &.highlightLine {
      &::before {
        border-bottom: 2px solid #f44336;
      }
    }

    &::before {
      border-bottom: 0.5px solid #5e6366;
    }

    &:hover {
      &::before {
        border-bottom: 0.5px solid #000 !important;
      }
    }

    input {
      padding: 0px 4px 4px;
    }
  }

  .counterDiv {
    display: flex;
    align-items: center;

    position: absolute;
    bottom: -0.5px;
    background: #f1f1f1;
    height: 20px;
    width: 94%;
    padding-left: 15px;
    border-radius: 1px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);

    font-family: 'Roboto';
    font-style: normal;
    font-weight: 300;
    font-size: 11px;
    line-height: 11px;
    color: #5e5e5e;
  }
`;

export const StyledTextareaAutosize = styled(TextareaAutosize)`
  border: none;
  border-bottom: ${(props) =>
    props.highlightLineInEdit ? '2px solid #f44336' : '0.5px solid #5e6366'};
  outline: none;
  padding: 8px;
  resize: none; // Caso queira evitar que o usuário redimensione o textarea
  transition: border-bottom 0.4s ease-in-out;
  min-height: 25px; // Altura inicial do textarea
  background-color: transparent; // Cor de fundo do textarea

  &:focus {
    border-bottom: ${(props) =>
      props.highlightLineInEdit ? '2px solid #f44336' : '2px solid #3F51B5'};
    transition: border-bottom 0.4s ease-in-out;
  }
`;
